import {useState, useEffect} from "react";
import {urlApiDataCRGCI, apiKeyDataCRGCI} from "../helper/api";
import {updateInfluenceZoneData} from "../components/ClusterFilter/data";

export interface IImpactArea {
  value: string;
  label: string;
}

interface IImpactAreaResponse {
  data: Array<{
    id: number;
    documentId: string;
    name: string;
    createdAt: string;
    updatedAt: string;
    publishedAt: string;
  }>;
  meta: {
    pagination: {
      page: number;
      pageSize: number;
      pageCount: number;
      total: number;
    };
  };
}

const DEFAULT_IMPACT_AREAS: IImpactArea[] = [];

export const useFetchImpactAreas = () => {
  const [impactAreas, setImpactAreas] =
    useState<IImpactArea[]>(DEFAULT_IMPACT_AREAS);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    updateInfluenceZoneData(DEFAULT_IMPACT_AREAS);

    const fetchImpactAreas = async () => {
      if (!urlApiDataCRGCI || !apiKeyDataCRGCI) {
        console.warn(
          "API URL или ключ CRGCI не найдены, используем дефолтные данные impact areas"
        );
        return;
      }

      setIsLoading(true);
      setError(null);

      try {
        const url = `${urlApiDataCRGCI}/api/impact-areas?populate=*`;

        const response = await fetch(url, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${apiKeyDataCRGCI}`,
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }

        const data: IImpactAreaResponse = await response.json();

        if (data?.data && Array.isArray(data.data)) {
          const transformedData: IImpactArea[] = data.data.map((item) => {
            const name = item.name || "Неизвестная зона";
            return {
              value: name,
              label: name,
            };
          });

          if (transformedData.length > 0) {
            setImpactAreas(transformedData);
            updateInfluenceZoneData(transformedData);
          } else {
            console.warn(
              "Получен пустой массив impact areas, используем дефолтные"
            );
          }
        } else {
          console.warn(
            "Неожиданная структура данных API, используем дефолтные impact areas"
          );
        }
      } catch (err) {
        const error =
          err instanceof Error ? err : new Error("Неизвестная ошибка");
        setError(error);
        console.error("Ошибка загрузки impact areas:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchImpactAreas();
  }, []);

  return {
    impactAreas,
    isLoading,
    error,
    refetch: () => {
      // функция для повторной загрузки
    },
  };
};
